module.exports = __webpack_public_path__ + "assets/7a3668d1fce3dd5331084114afec0f77.svg";